// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'

export default class HeadingComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = {}
  }

  async require() { 
  }

  mount() { 
  }
  
}
